<template>
  <div>
    <v-container
      v-if="loaded"
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="8" xs="12">
              <span v-if="!myOwn" @click="routeUser()" class="pointer hover">
                <Avatar
                  v-if="user.avatar != null"
                  class="timeline-avatar"
                  :src="`https://tradeinpool.com/upload/${user.avatar}.png`"
                  :size="40"
                ></Avatar>
                <Avatar v-else class="timeline-avatar" :username="user.username" :size="40"></Avatar>
              </span>

              <span
                v-if="!myOwn"
                @click="routeToDiary"
                class="pointer subheadline mt-3 ml-12"
              >{{user.username}}'s Trading Diary</span>
              <span v-else @click="routeToDiary" class="pointer subheadline">Trading Diary</span>
              <v-icon color="rgba(128, 143, 156, 1)">keyboard_arrow_right</v-icon>
              <v-chip class color="rgba(128, 143, 156, 0.2)" label outlined>
                <span class="date-font text-grey mr-1">Detail of</span>
                <span class="date-font text-green">{{detailDateString}}</span>
              </v-chip>
            </v-col>
            <v-col cols="4" xs="12">
              <div class="float-right">
                <div class="px-2 py-1 headline-font text-white mt-1 record-card card-light">
                  <span class="date-font mr-3">Today P/L:</span>
                  <span
                    class="pl-font"
                    v-bind:class="stats.equity[stats.equity.length-1] > 0 ? 'up' : 'down'"
                  >$ {{stats.equity[stats.equity.length-1].toFixed(2)}}</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col xl="9" lg="9" md="9" sm="12" class="pt-2">
          <v-row class="pa-0">
            <v-col cols="6" class="pt-0">
              <span class="headline-font text-grey">Trading Activity</span>

              <div
                v-if="timelineTrades.length == 0"
                class="record-card pa-4 mb-6 card-light text-font"
                style="background-color: #333b47 !important"
              >No trading activity this day...</div>

              <transition-group name="list">
                <div
                  class="record-card card-light pa-4 mb-6 card-light"
                  v-for="record in timelineTrades"
                  :key="record.created"
                >
                  <component :is="componentLookup[record.type]" :record="record"></component>
                  <div v-if="record._images" class="width-full float-left">
                    <vue-picture-swipe small :items="record._images"></vue-picture-swipe>
                  </div>
                </div>
              </transition-group>
            </v-col>
            <v-col cols="6" class="pt-0">
              <span class="headline-font text-grey">Notes</span>
              <v-card
                flat
                class="pa-4"
                style="background-color: #333b47 !important;margin-bottom:2px !important"
              >
                <div class="width-full mb-4">
                  <span class="headline-font text-white">Trade Ideas {{detailDateString}}</span>
                  <img
                    v-if="data.feeling>0"
                    class="float-right opacity"
                    style="opacity: 0.7"
                    height="30"
                    :src="'https://tradeinpool.com/img/emoji/'+data.feeling+'.png'"
                  />
                </div>
                <div class="width-full">
                  <div
                    v-if="data._images.length>0"
                    style="float:left; width: 145px; height: 135px;margin-right:10px"
                  >
                    <vue-picture-swipe :items="data._images.slice(0,1)"></vue-picture-swipe>
                  </div>
                  <p style="line-height:18px;margin-bottom:4px !important">
                    <span
                      v-if="data.description.length>0"
                      class="date-font text-white"
                    >{{diaryTime}}</span>

                    <span v-if="data.description.length>0" class="text-font px-1">|</span>
                    <span class="text-font">
                      <TextSlicer :text="data.description" :maxLength="600" />
                    </span>
                  </p>
                  <div v-if="data.keywords.length > 1" class="width-full float-left pa-0 mb-2">
                    <v-chip-group>
                      <v-chip small v-for="keyword in data.keywords" :key="keyword">{{ keyword }}</v-chip>
                    </v-chip-group>
                  </div>
                  <div class="width-full float-left mt-0 pt-0" v-if="data._images.length>1">
                    <vue-picture-swipe small :items="displayImgRest"></vue-picture-swipe>
                  </div>
                </div>
              </v-card>
              <TextInput
                lightBcg
                :sendBtn="true"
                placeholder="Idea comment..."
                @imgData="imgData"
                @textData="textData"
                @sending="sendMessage"
                :reset="textInputReset"
                :sending="sending"
                icon
                upload
              />

              <transition-group name="list">
                <div
                  class="record-card pa-4 pt-2"
                  v-for="(record) in timelineComments"
                  :key="record.created"
                  style="margin-top: 2px"
                  :style="record.id == $route.params.message ? 'background-color: #474e59 !important' : 'background-color: #28303d !important'"
                >
                  <chat :record="record"></chat>
                  <div v-if="record._images" class="width-full float-left">
                    <vue-picture-swipe small :items="record._images"></vue-picture-swipe>
                  </div>
                </div>
              </transition-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col xl="3" lg="3" md="3" sm="12" class="pl-4 pr-4 pt-7">
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card flat>
                <MiniGauge :data="stats.successRate" />
              </v-card>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card flat>
                <MiniEquity source="direct" :data="stats.equity" />
              </v-card>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card class="pb-4" flat>
                <MiniTradeResults
                  source="direct"
                  :data="{DDs:stats.DDs, RUs:stats.RUs, PLs:stats.PLs}"
                />
              </v-card>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card class="pb-4 px-2" flat>
                <Visitors :visitors="data._visitors" />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="width-full" style="text-align:center;margin-top: 120px" v-else>
      <v-progress-circular :size="100" :width="7" color="#4dbac0" indeterminate>
        <div class="text-center">
          <div>
            <img class="brand-img" width="50" src="https://tradeinpool.com/img/logo.svg" />
          </div>
          <div>loading...</div>
        </div>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
import VuePictureSwipe from "vue-picture-swipe";
import TextSlicer from "@/components/textSlicer.vue";
import { mapGetters } from "vuex";
var moment = require("moment-timezone");
import TextInput from "@/components/textInputBig.vue";
import Visitors from "@/components/visitors.vue";
import chat from "./timelineCards/message.vue";
import zone from "./timelineCards/zone.vue";
import diary from "./timelineCards/diary.vue";
import zonedelete from "./timelineCards/zonedelete.vue";
import trade from "./timelineCards/tradeOpen.vue";
import flat from "./timelineCards/tradeClose.vue";
import preparation from "./timelineCards/preparation.vue";
import MiniSeven from "@/components/minicharts_v2/miniSeven.vue";
import MiniWeek from "@/components/minicharts_v2/miniWeek.vue";
import MiniGauge from "@/components/minicharts_v2/miniGauge.vue";
import MiniEquity from "@/components/minicharts_v2/miniEquity.vue";
import MiniTradeResults from "@/components/minicharts_v2/miniTradeResults.vue";
import axios from "axios";
import Avatar from "vue-avatar";
export default {
  name: "DiaryDetail",
  components: {
    Visitors,
    TextSlicer,
    MiniTradeResults,
    MiniEquity,
    MiniSeven,
    MiniWeek,
    MiniGauge,
    Avatar,
    chat,
    zone,
    diary,
    zonedelete,
    trade,
    flat,
    preparation,
    VuePictureSwipe,
    TextInput
  },
  data() {
    return {
      
      sending: false,
      msgSelected: false,
      isActive: false,
      componentLookup: {
        "Trade Prepare": "preparation",
        "Trade Open": "trade",
        "Trade Close": "flat",
        Message: "chat",
        "New Zone": "zone",
        "Deleted Zone": "zonedelete",
        "Trading Diary": "diary"
      },
      displayImg: [],
      displayImgRest: [],
      detailDateString: moment(this.$route.params.date).format("dddd LL"),
      detailDate: new Date(this.$route.params.date),
      textInputReset: new Date(),
      myOwn: false,
      loaded: false,
      data: [],
      timelineTrades: [],
      timelineComments: [],
      statsArr: [],
      //user data
      user: null,
      //chart data
      stats: {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: [0],
        profits: 0,
        losts: 0,
        RUs: [],
        DDs: [],
        PLs: [],
        openRisk: false,
        openDD: 0,
        openRU: 0,
        openPL: 0,
        openArr: []
      },
      newItem: {
        images: [],
        description: null
      }
    };
  },
  computed: {
    ...mapGetters(["timezone", "username"]),
    diaryTime() {
      return moment.tz(this.data.createdAt, this.timezone).format("hh:mm");
    }
  },
  watch: {},
  methods: {
    
    statsRecalc() {
      this.stats.successRate = 0;
      this.stats.profits = 0;
      this.stats.losts = 0;
      this.stats.equity = [0];
      this.stats.DDs = [0];
      this.stats.RUs = [0];
      this.stats.PLs = [0];
      this.stats.oepnDD = 0;
      this.stats.openRU = 0;
      this.stats.openPL = 0;
      //var arrEq = [];
      this.statsArr.forEach(trade => {
        this.stats.PLs.push(trade.data.OpenProfitLoss);
        if (trade.data.FlatToFlatMaximumOpenPositionLoss)
          this.stats.DDs.push(trade.data.FlatToFlatMaximumOpenPositionLoss);
        //else this.stats.DDs.push(0);
        else this.stats.DDs.push(trade.data.FlatToFlatMaximumOpenPositionLoss);
        if (trade.data.FlatToFlatMaximumOpenPositionProfit)
          this.stats.RUs.push(trade.data.FlatToFlatMaximumOpenPositionProfit);
        //else this.stats.RUs.push(0);
        else
          this.stats.RUs.push(trade.data.FlatToFlatMaximumOpenPositionProfit);
        if (this.stats.equity.length > 0)
          this.stats.equity.push(
            this.stats.equity[this.stats.equity.length - 1] +
              trade.data.OpenProfitLoss
          );
        else this.stats.equity.push(trade.data.OpenProfitLoss);

        if (trade.data.OpenProfitLoss > 0) {
          this.stats.profits++;
        } else {
          this.stats.losts++;
        }
      });
      //this.stats.equity = arrEq
      this.stats.successRate =
        (this.stats.profits / (this.stats.profits + this.stats.losts)) * 100;
    },
    liveChart() {
      var pl = 0;
      var DD = 0;
      var RU = 0;
      this.stats.openArr.forEach(open => {
        pl += open.data.OpenProfitLoss;
        DD += open.data.FlatToFlatMaximumOpenPositionLoss;
        RU += open.data.FlatToFlatMaximumOpenPositionProfit;
      });
      if (this.stats.openArr.length > 0) {
        if (!this.openRisk) {
          this.stats.DDs.push(DD);
          this.stats.RUs.push(RU);
          this.stats.PLs.push(pl);
          this.openRisk = true;
          this.stats.equity.push(
            this.stats.equity[this.stats.equity.length - 1] + pl
          );
        } else {
          this.stats.DDs[this.stats.DDs.length - 1] = DD;
          this.stats.RUs[this.stats.RUs.length - 1] = RU;
          this.stats.PLs[this.stats.PLs.length - 1] = pl;
          this.$set(
            this.stats.equity,
            this.stats.equity.length - 1,
            this.stats.equity[this.stats.equity.length - 2] + pl
          );
          //this.stats.equity[this.stats.equity.length - 1] =
          //  this.stats.equity[this.stats.equity.length - 2] + pl;
        }
      } else {
        this.openRisk = false;
        this.statsRecalc();
      }
    },
    openResult(updateData) {
      var already = false;
      var finded = 0;
      this.stats.openArr.forEach((open, index) => {
        if (open.id == updateData.id) {
          already = true;
          finded = index;
        }
      });

      if (!already) {
        this.stats.openArr.push(updateData);
      } else {
        this.$set(this.stats.openArr, finded, updateData);
      }
      this.liveChart();
    },
    openRemove(updateData) {
      var finded = 0;
      var already = false;
      this.stats.openArr.forEach((open, index) => {
        if (open.id == updateData.id) {
          finded = index;
          already = true;
        }
      });
      if (already) {
        this.stats.openArr.splice(finded, 1);
      }
      if (this.stats.openArr.length == 0) this.statsRecalc();
    },
    resetData() {
      this.textInputReset = new Date();
      this.newItem = {
        images: [],
        description: null
      };
    },
    routeToDiary() {
      this.$router.push({
        name: "Diary",
        params: { name: this.$route.params.name }
      });
    },
    routeUser() {
      this.$router.push({
        name: "user",
        params: { name: this.$route.params.name }
      });
    },
    sendMessage() {
      if (this.newItem.description || this.newItem.images.length > 0) {
        //this.$emit("loading", true);
        // requred fields check
        this.sending = true;
        // prepare api data
        let formData = new FormData();
        //if (this.parentType == "Trades" || this.parentType == "Diary")
        formData.append("owner", this.$route.params.name);
        formData.append("parentType", "Diary");
        formData.append("_parentId", this.data._id);
        formData.append("description", this.newItem.description);
        formData.append("urlDate", this.$route.params.date);
        formData.append("subtype", "Idea comment");
        this.newItem.images.forEach(fileItem => {
          formData.append("img", fileItem);
        });

        axios
          .post("https://tradeinpool.com:3001/api/add/message/", formData)
          .then(() => {
            this.resetData();
            //var thiis = this;
            this.sending = false;
            this.flash("Idea comment send", "success", {
              timeout: 2000
            });
            setTimeout(() => {
              //this.$emit("loading", false);
            }, 1000);
          });
      }
    },
    imgData(data) {
      this.newItem.images = data;
    },
    textData(data) {
      this.newItem.description = data;
    },
    setData(data) {
      this.data = data;
      this.data._timeline.forEach(timeline => {
        if (
          timeline.type == "New Zone" ||
          timeline.type == "Deleted Zone" ||
          timeline.type == "Trade Close" ||
          timeline.type == "Trade Open" ||
          timeline.type == "Trade Prepare"
        ) {
          this.timelineTrades.push(timeline);
        }
        if (timeline.subtype == "Idea comment") {
          this.timelineComments.push(timeline);
        }
        if (timeline.type == "Trade Close") {
          this.statsArr.unshift(timeline);
        }
        if (timeline.type == "Trade Open" && timeline.active) {
          this.stats.openArr.push(timeline);
          /*
          this.stats.openRisk = true
          this.stats.oepnDD += timeline.data.FlatToFlatMaximumOpenPositionLoss;
          this.stats.oepnRU += timeline.data.FlatToFlatMaximumOpenPositionProfit;
          this.stats.oepnPL += timeline.data.OpenProfitLoss;
          */
        }
      });
      this.loaded = true;
      if (this.data._images.length > 0) {
        this.displayImg.push(this.data._images[0]);
      }
      if (this.data._images.length > 1) {
        this.data._images.forEach((image, index) => {
          if (index > 0) {
            image.thumbnail = image.thumbnail.replace("thumb", "mini");
            this.displayImgRest.push(image);
          }
        });
      }
      this.scrollToId();
      this.statsRecalc();
      // ad trades to one aray for stat
    },
    scrollToId() {
      if (this.$route.params.message)
        setTimeout(() => {
          var element = document.getElementById(this.$route.params.message);
          var headerOffset = 90;
          var elementPosition = element.getBoundingClientRect().top;
          var offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });

          //document
          //  .getElementById(this.$route.params.message)
          //  .scrollIntoView({ block: "start", behavior: "smooth" });
        }, 500);
    },
    getDetail() {
      axios
        .post("https://tradeinpool.com:3001/api/request/diary/", {
          method: "detail",
          user: this.$route.params.name,
          date: this.$route.params.date
        })
        .then(response => {
          this.setData(response.data);
        });
    },

    getUser() {
      axios
        .post("https://tradeinpool.com:3001/api/request/user/", {
          method: "basic",
          name: this.$route.params.name
        })
        .then(response => {
          this.user = response.data;
        });
    }
  },
  created() {
    if (this.$route.params.name == this.username) {
      this.myOwn = true;
    } else {
      this.myOwn = false;
      this.getUser();
    }

    this.getDetail();
  },
  mounted() {},
  sockets: {
    TIMELINE: function(data) {
      if (data.subtype == "Idea comment") {
        if (data._parentId == this.data._id) {
          this.timelineComments.unshift(data);
        }
      } else {
        if (data.user.username == this.$route.params.name) {
          var actionDate = moment(data.created).format("YYYY-MM-DD");

          if (data.action == "add") {
            if (actionDate == this.$route.params.date) {
              if (data.type == "Trade Close") {
                this.statsArr.push(data);
              }
              this.timelineTrades.unshift(data);
              this.statsRecalc();
            }
          }
          if (data.action == "update") {
            if (actionDate == this.$route.params.date) {
              if (data.type == "Trade Open" && data.active) {
                this.openResult(data);
              }
              if (data.type == "Trade Open" && !data.active) {
                this.openRemove(data);
              }

              this.timelineTrades.forEach((item, index) => {
                if (item.id == data.id) {
                  this.$set(this.timelineTrades, index, data);
                }
              });
            }
          }
        }
      }
      /*
        if (data.action == "update") {
          this.items.forEach((item, index) => {
            if (item.id == data.id) {
              this.$set(this.items, index, data);
            }
          });
        }
      */
    }
  }
};
</script>

<style scoped>
.date-picker {
  z-index: 50;
  position: absolute;
}
</style>